import BaseEntity from "@/core/misc/BaseEntity";
import Contact from "@/domains/Contacts/Contact";
import Core from "@/core/Core";
import TimeZone from "@/domains/TimeZones/TimeZone";

import TYPES       from "@/core/services/Changelogs/types";
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

/** id сотрудников с правом регистрировать внешний платёж (ручной) */
const PAYMENT_EXTERNAL_ID_EDITORS = [43, 44, 51, 52, 53, 242, 243, 286, 340, 564, 883, 1103];

@Title_ru_RU_Class('Сотрудник') // person → Person
class Person extends BaseEntity  {

  static Events = {
    Created: 'person:created',
    Updated: 'person:updated',
    Deleted: 'person:deleted'
  } as const;

  @Title_ru_RU('ФИО', TYPES.STRING)
  public name: string | null;

  @Title_ru_RU('Email', TYPES.STRING)
  public email: string | null;

  @Title_ru_RU('Контакты', TYPES.OBJECT)
  public contacts: Contact[];

  @Title_ru_RU('Часовой пояс', TYPES.OBJECT)
  public timeZone: TimeZone | null;

  @Title_ru_RU('Сотрудник в ИС Сибирского здоровья', TYPES.OBJECT)
  public swPortalEmployee: any | null;

  @Title_ru_RU('комментарий', TYPES.STRING)
  public comment: string | null;

  /** Право на extended debug на проде (сбор SQL, forceRollback) */
  public allowExtendedDebug: boolean = false;

  /** фронтовые поля */

  public partnerId: number;

  constructor() {
    super();
    this.partnerId = null;
    this.name = null;
    this.email = null;
    this.contacts = [];
    this.timeZone = null;
    this.swPortalEmployee = null;
  }

  static fromPartner(partnerId: number): Person {
    const person = new this();

    person.partnerId = partnerId;

    return person;
  }

  static fromServer(data: any, person = new Person()): Person {
    super.fromServer(data, person);

    person.contacts = Core.utils.hydrateArray(data.contacts, Contact.fromServer);
    person.timeZone = Core.utils.hydrate(data.timeZone, TimeZone.fromServer);
    person.swPortalEmployee = data.swPortalEmployee ?? null;

    return person;
  }

  /**
   * Право регистрировать внешний платёж (ручной).
   * Хардкод по id — переедет в ACL, когда придёт время.
   */
  get canEditPaymentExternalId(): boolean {
    return PAYMENT_EXTERNAL_ID_EDITORS.includes(this.id);
  }

  toString(): string {
    return this.name ?? '';
  }
}

export default Person;
